import React, { useState } from "react";
import { Link } from "react-router-dom"; // ✅ Use React Router
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// import images (if inside /src/assets)
import gooseLogo from "../assets/gooseLogo.png";
import headerShape from "../assets/header-bottom-shap.png";
import signupLeft from "../assets/signupLeft-img.png";
import guestIcon from "../assets/guest-icons.png";
import VerifyCodeModal from "../components/VerifyCodeModal";

const SignUp = () => {
  const [showModal, setShowModal] = useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  
  const { t } = useTranslation();

  return (
    <>
      <header>
        <div className="btm-header header-without-login pt-3 pb-3">
          <div className="container">
            <div className="inner_header d-flex flex-wrap align-items-center justify-content-between">
              <div className="inner-btm-header d-flex align-items-center justify-content-between w-100">
                <div className="logo_header">
                  <Link to="/">
                    <img src={gooseLogo} alt="Logo" />
                  </Link>
                </div>
                <div className="btn-box-header-right">
                  <Link to="/sign-in" className="btn btn-primary btn-header rounded-pill">
                  {t("login")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main position-relative">
        <div className="bottom-main-shap position-absolute top-0">
          <img src={headerShape} alt="Header Shape" />
        </div>

        <div className="credential-sec position-relative signUp-sec">
          <div className="container">
            <div className="inner-credential-sec d-flex flex-wrap align-items-center">
              <div className="left-img">
                <img src={signupLeft} alt="Sign Up" />
              </div>
              <div className="right-details">
                <div className="details-inner-right">
                  <div className="heading-box d-flex align-items-center justify-content-between gap-2 pb-2">
                    <h2 className="m-0">{t("signUpTitle")}</h2>
                    <Link to="#" className="btn btn-primary d-flex align-items-center gap-1 justify-content-center">
                      <img src={guestIcon} alt="Guest" />
                      <span>{t("guest")}</span>
                    </Link>
                  </div>
                  <p>{t("signUpSubtitle")}</p>
                  <div className="form-sec pt-0 mt-4">
                    <div className="row">
                      {/* First Name */}
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input type="text" className="form-control" id="firstName" placeholder="First Name" />
                          <label htmlFor="firstName">{t("firstName")}</label>
                        </div>
                      </div>

                      {/* Last Name */}
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input type="text" className="form-control" id="lastName" placeholder="Last Name" />
                          <label htmlFor="lastName">{t("lastName")}</label>
                        </div>
                      </div>

                      {/* Email */}
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input type="email" className="form-control" id="email" placeholder="name@example.com" />
                          <label htmlFor="email">{t("email")}</label>
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="col-md-6">
                        <div className="form-floating mb-3">
                          <input type="text" className="form-control" id="phone" placeholder="Phone Number" />
                          <label htmlFor="phone">{t("phoneNumber")}</label>
                        </div>
                      </div>
                      {/* Password */}
                      <div className="col-md-12">
                        <div className="position-relative mb-3">
                          <FloatingLabel controlId="password" label={t("password")}>
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              placeholder={t("password")}
                            />
                          </FloatingLabel>
                          <i
                            className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} position-absolute top-50 end-0 translate-middle-y me-3`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          />
                        </div>
                      </div>

                      {/* Confirm Password */}
                      <div className="col-md-12">
                        <div className="position-relative mb-3">
                          <FloatingLabel controlId="confirmPassword" label={t("createPassword")}>
                            <Form.Control
                              type={showConfirmPassword ? "text" : "password"}
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              placeholder={t("createPassword")}
                            />
                          </FloatingLabel>
                          <i
                            className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} position-absolute top-50 end-0 translate-middle-y me-3`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          />
                        </div>
                      </div>


                      {/* Terms Checkbox */}
                      <div className="col-md-12">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="form-check m-0 pt-2 pb-4">
                            <input className="form-check-input" type="checkbox" id="gridCheck" />
                            <label className="form-check-label" htmlFor="gridCheck">
                            {t("agreeTo")}{" "}
                              <Link to="#" className="text-red btn-for">
                              {t("terms")}
                              </Link>{" "}
                              {t("and")}{" "}
                              <Link to="#" className="text-red btn-for">
                              {t("privacyPolicy")}
                              </Link>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Submit */}
                      <div className="col-md-12">
                        <button className="btn btn-primary w-100" type="submit" onClick={() => setShowModal(true)}>
                        {t("createAccount")}
                        </button>
                      </div>

                      {/* Already have account */}
                      <div className="col-md-12 mb-4">
                        <p className="text-center">
                        {t("alreadyHaveAccount")}{" "}
                          <Link to="/sign-in" className="text-red btn-for">
                          {t("login")}
                          </Link>
                        </p>
                      </div>

                      {/* Social Login */}
                      <div className="col-md-12">
                        <div className="or-text text-center">
                          <span className="or-text">{t("orLoginWith")}</span>
                          <span className="line-shape"></span>
                        </div>
                      </div>
                      
                       {/* Social Login Buttons */}
                      
                      <div className="col-md-12">
                        <div className="social-box-bottom">
                          <ul className="list-unstyled d-flex align-items-center justify-content-center gap-2">
                            <li>
                              <Link to="#" className="social-btn">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12.0733C24 5.40546 18.6274 0 12 0C5.37262 0 0 5.40536 0 12.0733C0 18.0994 4.38825 23.0943 10.125 24V15.5633H7.07812V12.0733H10.125V9.41343C10.125 6.38755 11.9166 4.71615 14.6575 4.71615C15.9705 4.71615 17.3438 4.95195 17.3438 4.95195V7.92313H15.8306C14.3398 7.92313 13.875 8.85381 13.875 9.80864V12.0733H17.2031L16.6711 15.5633H13.875V24C19.6117 23.0943 24 18.0995 24 12.0733Z" fill="#1877F2"/></svg>   
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="social-btn">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#FFC107"/><path d="M3.15308 7.3455L6.43858 9.755C7.32758 7.554 9.48058 6 12.0001 6C13.5296 6 14.9211 6.577 15.9806 7.5195L18.8091 4.691C17.0231 3.0265 14.6341 2 12.0001 2C8.15908 2 4.82808 4.1685 3.15308 7.3455Z" fill="#FF3D00"/><path d="M11.9999 22C14.5829 22 16.9299 21.0115 18.7044 19.404L15.6094 16.785C14.5717 17.5742 13.3036 18.001 11.9999 18C9.39891 18 7.19041 16.3415 6.35841 14.027L3.09741 16.5395C4.75241 19.778 8.11341 22 11.9999 22Z" fill="#4CAF50"/><path d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#1976D2"/></svg>   
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="social-btn">
                                  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5172 10.5555C14.5078 8.95703 15.232 7.75234 16.6945 6.86406C15.8766 5.69219 14.6391 5.04766 13.0078 4.92344C11.4633 4.80156 9.77344 5.82344 9.15469 5.82344C8.50078 5.82344 7.00547 4.96563 5.82891 4.96563C3.40078 5.00313 0.820312 6.90156 0.820312 10.7641C0.820312 11.9055 1.02891 13.0844 1.44609 14.2984C2.00391 15.8969 4.01484 19.8133 6.1125 19.75C7.20937 19.7242 7.98516 18.9719 9.4125 18.9719C10.7977 18.9719 11.5148 19.75 12.7383 19.75C14.8547 19.7195 16.6734 16.1594 17.2031 14.5563C14.3648 13.218 14.5172 10.6375 14.5172 10.5555ZM12.0539 3.40703C13.2422 1.99609 13.1344 0.711719 13.0992 0.25C12.0492 0.310938 10.8352 0.964844 10.1437 1.76875C9.38203 2.63125 8.93437 3.69766 9.03047 4.9C10.1648 4.98672 11.2008 4.40313 12.0539 3.40703Z" fill="#313131"/></svg>   
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* End form-sec */}
                </div>
              </div>
            </div>
          </div>
        </div>
         <VerifyCodeModal show={showModal} handleClose={() => setShowModal(false)}/>
      </div> 
    </>
  );
};

export default SignUp;
